<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Revertir informe</h1>
  <div mat-dialog-content>
    <mat-form-field class="full-width">
      <mat-select formControlName="StudyReportReverseReason" placeholder="Motivo" required>
        <mat-option *ngFor="let studyReportReverseReason of studyReportReverseReasons" [value]="studyReportReverseReason">
          {{studyReportReverseReason.Name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="f.StudyReportReverseReason.errors && f.StudyReportReverseReason.errors.required">
        Seleccione un motivo
      </mat-error>
    </mat-form-field>
      <mat-form-field class="full-width">
        <textarea matInput placeholder="Observaciones"></textarea>
      </mat-form-field>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button mat-button type="submit">Guardar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>
